export function buildReelUrl(shortcode: string): string {
  return `https://www.instagram.com/reel/${shortcode}/`;
}

export function buildProfileUrl(username: string): string {
  return `https://www.instagram.com/${username}/`;
}
